import { booleanAttribute, Component, Input } from '@angular/core';

@Component({
  selector: 'sigecom-list-item',
  template: `
    <div class="w-full p-4 {{bgColor}} rounded-lg shadow-md relative"
      [ngClass]="{'border-[#C9C9C9] border-2' : outline}">
      <ng-content></ng-content>
    </div>
  `,
})
export class ListItemComponent {
  @Input() bgColor:string = "bg-white"
  @Input({transform: booleanAttribute}) outline : boolean = false;
}
